type AppTemplateListItem = {
  user_id: string;
  status: string;
  source_message_id?: string | null;
  public_access_level?: string | null;
  properties?: unknown;
};

function templateStatus(properties: unknown): string | null {
  if (!properties || typeof properties !== "object" || Array.isArray(properties)) {
    return null;
  }
  const template = (properties as Record<string, unknown>).template;
  if (!template || typeof template !== "object" || Array.isArray(template)) return null;
  const status = (template as Record<string, unknown>).status;
  return typeof status === "string" && status.trim() ? status : null;
}

const templateLifecycleStatuses = new Set([
  "preparing_template", "template", "retiring_template", "retire_failed",
]);

export function isAppTemplateLifecycleRecord(app: Pick<AppTemplateListItem, "properties">): boolean {
  return templateLifecycleStatuses.has(templateStatus(app.properties) ?? "");
}

export function isOwnedPublicAppTemplate(
  app: AppTemplateListItem,
  userId: string | null | undefined,
): boolean {
  return Boolean(userId)
    && app.user_id === userId
    && app.status === "ready"
    && (app.public_access_level === "reader" || app.public_access_level === "none")
    && templateStatus(app.properties) === "template";
}

export function isUserAppOrOwnedPublicTemplate(
  app: AppTemplateListItem,
  userId: string | null | undefined,
): boolean {
  return !isAppTemplateLifecycleRecord(app) || isOwnedPublicAppTemplate(app, userId);
}

export function isAppTemplateConversionEligible(
  app: AppTemplateListItem,
  isPlatformAdmin: boolean,
  sourceDocumentAvailable: boolean,
  userId?: string | null,
): boolean {
  return (isPlatformAdmin || Boolean(userId && app.user_id === userId))
    && app.status === "ready"
    && templateStatus(app.properties) === null
    && !(app.properties && typeof app.properties === "object" && !Array.isArray(app.properties)
      && "template_capture" in app.properties)
    && Boolean(app.source_message_id)
    && sourceDocumentAvailable;
}
